// Centralized base URLs for cross-service handoff.
//
// Defaults: root-relative /workbench-api/eln/ proxy paths, matching
// buildHubUrl() below — same-origin, so they work behind Cloudflare/TLS
// with no host-mapped ports (the old :18080/:9142 defaults triggered
// mixed-content blocking in production).
//
// Override via frontend/.env at build time if needed. CRA inlines
// REACT_APP_* variables into the bundle, so the values become baked-in once
// `npm run build` runs. Editing .env after the build has no effect.

export const ELN_API_BASE: string =
  process.env.REACT_APP_ELN_API_URL || '/workbench-api/eln';

export const ELN_UI_BASE: string =
  process.env.REACT_APP_ELN_UI_URL || '/workbench-api/eln/';

// Per-hub proxy slug. Hubs are reached through the platform proxy at
// /workbench-api/<slug>/ (dev/prod parity), matching getHubProxyUrl().
const HUB_DEFAULTS: Record<string, { slug: string }> = {
  admet:      { slug: 'admet' },
  metabolism: { slug: 'metabolism' },
  sar:        { slug: 'sar' },
  combi:      { slug: 'combi' },
};

export type HubName = keyof typeof HUB_DEFAULTS;

export function buildHubUrl(hubName: HubName, context?: {
  smiles?: string;
  moleculeId?: string | number;
  moleculeName?: string;
  fileId?: string | number;
  projectId?: string | number;
  projectName?: string;
  fileName?: string;
}): string {
  const cfg = HUB_DEFAULTS[hubName];
  // Match getHubProxyUrl(): root-relative proxy path, identical in dev and prod.
  const base = `/workbench-api/${cfg.slug}/`;
  if (!context) return base;
  const params = new URLSearchParams();
  if (context.smiles)       params.set('smiles', context.smiles);
  if (context.moleculeId)   params.set('molecule_id', String(context.moleculeId));
  if (context.moleculeName) params.set('molecule_name', context.moleculeName);
  if (context.fileId)       params.set('file_id', String(context.fileId));
  if (context.projectId)    params.set('project_id', String(context.projectId));
  if (context.projectName)  params.set('project_name', context.projectName);
  if (context.fileName)     params.set('file_name', context.fileName);
  const qs = params.toString();
  return qs ? `${base}?${qs}` : base;
}
